<template>
  <div>
    <el-row>
      <div class="left-justifying">
        <h3>操作日志记录</h3>
      </div>
      <div class="right-justifying">

      </div>
    </el-row>

    <div class="panel">
      <div class="panel-body">
        <el-row>
          <div class="advanced-search-location">
          </div>
          <div>
            <el-tabs v-model="activeTabName" :before-leave="tabsBeforeLeave">
              <el-tab-pane :label="'列表'" :name="'page'">
                <contract-record-page @to-look="toLook" ref="page">
                </contract-record-page>
              </el-tab-pane>
              <el-tab-pane :label="'详情'" :name="'detail'">
                <contract-record-detail ref="detail"></contract-record-detail>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

import ContractRecordPage from './contract-record-page';
import ContractRecordDetail from './contract-record-detail';

export default {
  name: "contract-record-main",
  components: {
    ContractRecordPage, ContractRecordDetail
  },
  data() {
    return {
      activeTabName: 'page',
      doQueryWhenTabPage: true,

      currentRowId: null,
    };
  },
  watch: {
    '$route': {
      deep: true,
      immediate: true,
      handler() {
        let query = this.$route.query;
        let id = query.id;
        if (id != null) {
          this.$nextTick(() => {
            this.callDetailLook(id);
          });
        } else {
          this.$nextTick(() => {
            this.showPageTab();
            this.callPageQuery();
          });
        }
      },
    },
  },
  methods: {
    setActiveTabName(tabName) {
      this.activeTabName = tabName;
    },
    showPageTab() {
      this.setActiveTabName('page');
    },
    showDetailTab() {
      this.setActiveTabName('detail');
    },
    tabsBeforeLeave(tabName) {
      if (tabName === 'page') {
        if (this.doQueryWhenTabPage) {
          this.callPageQuery();
        }
      } else if (tabName === 'detail') {
        // 不是add，默认look
        let id = this.obtainCurrentRowId();
        this.callDetailLook(id);
      }
    },
    setCurrentRowId(currentRowId) {
      this.currentRowId = currentRowId;
    },
    obtainCurrentRowId() {
      return this.currentRowId;
    },
    toLook(id) {
      this.showDetailTab();
      this.setCurrentRowId(id)
    },
    callPageQuery() {
      this.$refs.page.query();
    },
    callDetailLook(id) {
      this.$refs.detail.look(id);
    },
  },
}
</script>

<style scoped>

</style>